import type { FactoryEdit } from '@indutrust/factory-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import type { FactoryImportPayload } from './factory-actions-api-client.service';

/**
 * Workflow events for importing a factory from an external API source
 * (`POST /factories/create_from_api`).
 *
 * Pattern B (custom workflow).
 *
 * @example
 * const dispatch = injectDispatch(factoryImportEvents);
 * dispatch.importRequested({ payload: { provider: 'x', ref: '123' } });
 */
export const factoryImportEvents = eventGroup({
  source: 'factory.import',
  events: {
    importRequested: type<{ payload: FactoryImportPayload }>(),
    importSucceeded: type<{ factory: FactoryEdit }>(),
    importFailed: type<{ error: string }>(),
  },
});
